import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import { combineReducers } from 'redux';
import authReducer from '../app/features/slices/authSlice';
import userReducer from '../app/features/slices/userSlice';
import vendorReducer from '../app/features/slices/vendorSlice';
import orderReducer from '../app/features/slices/orderSlice';
import messageReducer from '../app/features/slices/messageSlice';
import notificationReducer from '../app/features/slices/notificationSlice';
import offerReducer from '../app/features/slices/offerSlice';

const appReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  vendor: vendorReducer,
  order: orderReducer,
  message: messageReducer,
  notification:notificationReducer,
  offer:offerReducer
});

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'user', 'vendor', 'order','message','notification','offer'],
};
const rootReducer = (state, action) => {
  if (action.type === 'auth/logout') {
    // clear all persisted slices
    state = undefined;
  }
  return appReducer(state, action);
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export const persistor = persistStore(store);
